import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { ClientSupportContext } from "./ClientSupportPageContext";

export const useClientSupportPageContext = () => {
  const context = useContext(ClientSupportContext);

  if (!context) {
    throw new HookOutOfContextError("useClientSupport", "ClientSupportContext");
  }

  return context;
};
